import { useState, useEffect, React }  from 'react'
import { Link} from 'react-router-dom';
// import TeachingShow from '../components/TeachingShow.js'
// const endpoint="http://localhost:3000" 
const api="https://cyrene-api.herokuapp.com"

export default function Teachings(props) {
 const [teachings, setTeachings]= useState([]);
  const getTeachings = async() => {
    try{
    const response = await fetch(`${api}/teachings` /*`${endpoint}/teachings`*/,
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    const requestTeachings = await response.json()
    setTeachings(requestTeachings)
    console.log(requestTeachings)
    }catch (error) {
      console.log(error)
    }
  }
   useEffect (() => {
    getTeachings()
  },[])
  return(
    <div >
      <h1> The Catechism of the Catholic Church</h1>
      <div className='teachingCardHolder'>
        {teachings.map(teaching => {
        return(
         <div key={teaching.id} className="teachingCard"> 
        <Link to={`/teachings/${teaching.id}`}>
        <h2>{teaching.title}</h2>
        </Link>
        <h3>Theme:<br/>{teaching.temptation}</h3>
        {/* <h3>{teaching.bibleVerse}</h3> */}
        {/* <h4>{teaching.reading}</h4> */}
        {/* <h3>CCC{teaching.cccParagraph}</h3> */}
        {/* <h4>{teaching.content}</h4> */}
        {/* <h3>Let us pray,</h3> */}
        {/* <h4>{teaching.prayer}</h4> */}
          </div>
          )})
        }
      </div>
    </div>
  )
}